import { render, staticRenderFns } from "./dish-image.vue?vue&type=template&id=768eb082&scoped=true"
import script from "./dish-image.vue?vue&type=script&lang=js"
export * from "./dish-image.vue?vue&type=script&lang=js"
import style0 from "./dish-image.vue?vue&type=style&index=0&id=768eb082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768eb082",
  null
  
)

export default component.exports